import './App.css'
import { About } from './components/About'
import { BackgroundOrbs } from './components/BackgroundOrbs'
import { Contact } from './components/Contact'
import { Hero } from './components/Hero'
import { Journey } from './components/Journey'
import { Navbar } from './components/Navbar'
import { Projects } from './components/Projects'
import { Skills } from './components/Skills'
import { useParallaxVars } from './hooks/useParallaxVars'

const App = () => {
  useParallaxVars()

  return (
    <div className="timeline-app">
      <BackgroundOrbs />
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Journey />
      <Projects />
      <Contact />
    </div>
  )
}

export default App
